import type { ReactNode } from "react";
import { ThemeModeProvider } from "@/theme/ThemeModeProvider";

export function ThemeProvider({ children }: { children: ReactNode }) {
  return <ThemeModeProvider>{children}</ThemeModeProvider>;
}
